import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pl',
    debug: false,
    resources: {
      pl: {
        translation: {
          login: 'Logowanie',
          logout: 'Wyloguj',
          dashboard: 'Dashboard',
          vehicles: 'Pojazdy',
          users: 'Pracownicy',
          repairs: 'Naprawy',
          faults: 'Usterki',
          documents: 'Dokumenty',
          reports: 'Raporty',
          messages: 'Komunikator',
          equipment: 'Wyposażenie',
        }
      },
      en: {
        translation: {
          login: 'Login',
          logout: 'Logout',
          dashboard: 'Dashboard',
          vehicles: 'Vehicles',
          users: 'Employees',
          repairs: 'Repairs',
          faults: 'Faults',
          documents: 'Documents',
          reports: 'Reports',
          messages: 'Messenger',
          equipment: 'Equipment',
        }
      }
    }
  });

export default i18n;
